import * as React from "react";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useApiClient } from "../../../api";
import { useNavigate } from "react-router-dom";

export const BulkAssignStudentDialog = ({
  open,
  setOpen,
  schoolClasses,
  students,
}) => {
  const ApiClient = useApiClient();
  const [schoolClass, setSchoolClass] = useState({});
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const response = await ApiClient.schools.assignStudentsToClass({
        students: students,
        schoolClass: schoolClass.id,
      });
      if (response.success) {
        setOpen(false);
        navigate(`/management/classes/view/${schoolClass.id}`);
      } else {
        console.log("Failed to assign student");
      }
    } catch (error) {
      console.error("Failed to assign student", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant={"h4"}>Add Students to Class</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          disablePortal
          autoSelect
          options={schoolClasses}
          value={schoolClass}
          onChange={(_, newValue) => setSchoolClass(newValue)}
          getOptionLabel={(option) =>
            option.name
              ? `${option?.name} (Year ${option.yearGroup.yearGroup}, ${option.school.name})`
              : ""
          }
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          fullWidth
          slotProps={{
            clearIndicator: {
              sx: {
                border: "none",
                boxShadow: "none",
                "&:hover": {
                  background: "transparent",
                },
                height: 5,
              },
            },
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Class" />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"outlined"}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant={"contained"}
          disabled={!schoolClass}
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};
